<!-- Start Footer Area -->
<footer class="footer-area">
  <div class="footer-container">
    <div class="footer-top">
      <div class="footer-brand">
        <a routerLink="/" class="footer-logo-link">
          <img src="assets/img/kmlogo1.png" alt="Kitchen Magic">
        </a>
        </div>

      <div class="footer-links">
        <div class="footer-column">
          <h4 class="footer-title">Quick Links</h4>
          <ul class="footer-list">
            <li><a routerLink="/about">About Us</a></li>
            <li><a routerLink="/product-menu">Menu</a></li>
            <li><a routerLink="/blog-grid">Blog</a></li>
            <li><a routerLink="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h4 class="footer-title">Contact Us</h4>
          <ul class="footer-list footer-contact">
            <li>
              <i class='bx bx-map'></i>
              <span>15171, Los Gatos Blvd, Los Gatos, CA 95032, USA</span>
            </li>
            <li>
              <i class='bx bx-envelope'></i>
              <a href="mailto:kitchenmagic013&#64;gmail.com">kitchenmagic013&#64;gmail.com</a>
            </li>
            <li>
              <i class='bx bx-phone'></i>
              <a href="tel:+16698710461">‎+1 (669) 871-0461</a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h4 class="footer-title">Follow Us</h4>
          <div class="footer-social">
            <a href="https://www.facebook.com/" target="_blank" class="social-link">
              <i class='bx bxl-facebook'></i>
            </a>
            <a href="https://www.instagram.com/" target="_blank" class="social-link">
              <i class='bx bxl-instagram'></i>
            </a>
            <a href="https://www.twitter.com/" target="_blank" class="social-link">
              <i class='bx bxl-twitter'></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="copyright-section">
          <p class="footer-bottom-text">Copyright © 2026 Kitchen Magic. All rights reserved.</p>
        </div>
        <div class="footer-divider"></div>
        <div class="developer-section">
          <p class="footer-bottom-text">Developed By <a href="https://fuestech.com/" target="_blank">Fues Technology Solutions</a></p>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Sticky Bottom Bar -->
  <div class="mobile-sticky-bar">
    <a href="tel:+16698710461" class="sticky-bar-item">
      <i class='bx bx-phone'></i>
      <span>Call</span>
    </a>
    <a href="https://www.google.com/maps/search/?api=1&query=15171+Los+Gatos+Blvd,+Los+Gatos,+CA" target="_blank" class="sticky-bar-item">
      <i class='bx bx-map'></i>
      <span>Directions</span>
    </a>
    <a routerLink="/product-menu" class="sticky-bar-item">
      <i class='bx bx-food-menu'></i>
      <span>Order</span>
    </a>
  </div>
</footer>
<!-- End Footer Area -->
